import Matterport from "./matterport-body";

export default Matterport;